/* Carrusel Glomend compartido. Uso:
   <div data-gh-carousel><div data-gh-track>…cards…</div>
     <button data-gh-prev>…</button><button data-gh-next>…</button>
     <div data-gh-dots></div></div>
   Reglas binding del handoff: sin autoplay, flechas con loop, dots clicables/teclado,
   scroll por ancho de card medido, prefers-reduced-motion → instantáneo.
   Solo LTR: asume scrollLeft creciente hacia la derecha (sin soporte RTL) — ok para esta tienda. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    if (root.dataset.ghReady) return;
    var track = root.querySelector('[data-gh-track]');
    var prev = root.querySelector('[data-gh-prev]');
    var next = root.querySelector('[data-gh-next]');
    var dotsWrap = root.querySelector('[data-gh-dots]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) return;
    root.dataset.ghReady = '1';
    var cur = 0; /* página actual — fuente de verdad, no se relee de scrollLeft salvo al asentar el scroll */
    var builtCount = -1; /* cantidad de dots ya construidos; evita reconstruir en cada scroll */
    function cardW() {
      var s = getComputedStyle(track);
      var w = cards[0].getBoundingClientRect().width + (parseFloat(s.columnGap || s.gap) || 0);
      return w > 1 ? w : 0; /* descarta anchos ínfimos (solo gap) de una card oculta */
    }
    function maxScroll() {
      var m = track.scrollWidth - track.clientWidth;
      return m > 0 ? m : 0;
    }
    function pages() {
      var w = cardW();
      if (!w) return 1; /* evita división por 0/NaN si una card está oculta */
      var max = maxScroll();
      if (max < 1) return 1;
      var full = Math.floor(max / w); /* pasos de card enteros que caben */
      var rest = max - full * w;
      /* un resto menor a un cuarto de card no merece su propio dot; la última
         página aterriza en max igual, así que no queda nada inalcanzable */
      return full + 1 + (rest > w * 0.25 ? 1 : 0);
    }
    function go(p) {
      var n = pages();
      cur = ((p % n) + n) % n; /* loop infinito */
      var w = cardW();
      var max = maxScroll();
      /* la última página aterriza EXACTAMENTE en el final: avanzando solo de a
         un ancho de card, la cola de una última card parcial nunca se alcanza
         (en el collage de reseñas eran 261px y la última reseña no se veía
         entera ni con las flechas ni con los dots). */
      var left = cur === n - 1 ? max : Math.min(cur * w, max);
      track.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
      syncDots();
    }
    function buildDots() {
      if (!dotsWrap) return;
      var n = pages();
      if (n === builtCount) return; /* solo reconstruir cuando cambia la cantidad de páginas */
      builtCount = n;
      cur = Math.min(cur, n - 1); /* la página actual no puede apuntar fuera del nuevo total */
      dotsWrap.innerHTML = '';
      if (n < 2) {
        dotsWrap.hidden = true;
        return;
      }
      dotsWrap.hidden = false;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gh-dot';
        b.setAttribute('aria-label', 'Go to page ' + (i + 1) + ' of ' + n);
        b.dataset.page = i;
        b.addEventListener('click', function (e) { go(parseInt(e.currentTarget.dataset.page, 10)); });
        dotsWrap.appendChild(b);
      }
      syncDots();
    }
    function syncDots() {
      if (!dotsWrap) return;
      var nodes = dotsWrap.children;
      for (var i = 0; i < nodes.length; i++) {
        var isActive = i === cur;
        nodes[i].classList.toggle('is-active', isActive);
        if (isActive) nodes[i].setAttribute('aria-current', 'true');
        else nodes[i].removeAttribute('aria-current');
      }
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = cardW();
        var max = maxScroll();
        var n = pages();
        /* re-sincroniza tras swipe manual. Estar al final es la última página
           aunque el paso no sea múltiplo exacto del ancho de card, o el último
           dot nunca se encendería. */
        if (max > 0 && track.scrollLeft >= max - 1) cur = n - 1;
        else cur = w ? Math.min(Math.round(track.scrollLeft / w), n - 1) : 0;
        syncDots();
      }, 90);
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    if ('ResizeObserver' in window) new ResizeObserver(buildDots).observe(track);
    buildDots();
  }
  function scan(scope) {
    (scope || document).querySelectorAll('[data-gh-carousel]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });
})();
